/** True when the signed-in user has Occasia admin privileges. */
export const isAdminUser = (userProfile) =>
  userProfile?.is_admin === true ||
  userProfile?.role === 'admin' ||
  userProfile?.user_type === 'admin';

export const buildAdminOrganizerProfilePath = ({ userId, email } = {}) => {
  if (userId) {
    return `/admin/organizers?userId=${encodeURIComponent(String(userId))}`;
  }
  if (email) {
    return `/admin/organizers?email=${encodeURIComponent(String(email).trim())}`;
  }
  return '/admin/organizers';
};

export const buildAdminBookingViewPath = (bookingId, { userId, email } = {}) => {
  if (!bookingId) return '/admin/organizers';
  const viewKey = userId || email;
  if (!viewKey) {
    return `/profile/bookings/${encodeURIComponent(String(bookingId))}`;
  }
  const params = new URLSearchParams({
    adminViewUserId: String(viewKey)
  });
  return `/profile/bookings/${encodeURIComponent(String(bookingId))}?${params.toString()}`;
};
